<style scoped>
    @import url("../../styles/smartControl/atuzIA.scss");
</style>

<template>
    <div class="box_atuzIA">

        <!-- controlador -->
        <!-- atuador -->
        <!-- configurações para o dia de hoje 

        <div>Desabilitado</div>-->

        <div class="dt_atuz mb-1">
            <v-chip>{{ el_ia_exib.data }}</v-chip>
        </div>

        <div class="painel_atuz">
            <div class="card_atuz mr-" v-for="(el,i) in li_ia_exib" :key="i">
                <v-icon size="36">{{ el.icon }}</v-icon>
                <span :style="{'font-size':'0.8rem'}">{{ el.atu }}</span>
                <div>
                    <span>{{ el.valor }}</span>
                    <span class="ml-1">{{ el.un }}</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

export default {

    //components:{AtuadoresSobIA,CardIA},

    data() {
        return {
            //
            flagLoading:true,

            //
            el_ia_exib:{},
            li_ia_exib:[],
        }
    },

    methods:{
        //
        preInit() {
            
            // iniciar com manuseio da escolha de qual sistema utilizar
            //this.sistema = 'upinc1'
            this.sistema = this.$store.state.sistemaSC // 14/08/2025

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            //let cl = contentUser.email // de volta ao padrao 08/07/2025
            //cl = "cliente2" // temporário
            let cl = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            let self = this

            //let params = {'cliente':cl, 'flag_front':'json'} // -- teste 04/05/2025
            let params = {'cliente':cl, 'sistema':this.sistema, 'flag_front':'json'} // -- teste 07/08/2025

            //console.log('params: ',params)

            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                // ( v2 ) --> 14/08/2025
                const el = res.data.result
                self.liResIA = el['res_ia']

                if (self.liResIA.length > 0) { 
                    self.liResIA = self.liResIA.reverse(); 
                    self.el_ia_exib = self.liResIA[0] // -- mais recente

                    let dados = self.el_ia_exib.manejo
                    for (const [chave, valor] of Object.entries(dados)) {
                        //console.log(`Chave: ${chave} | Valor: ${valor}`);

                        const partes = chave.split("_");
                        //console.log(`partes: ${partes}`);
                        //console.log(`partes: ${partes[2]}`);

                        let atu = null;
                        let icon = null;
                        if (partes[1] == 'vent') { atu = 'Ventilação'; icon = 'mdi-weather-windy'; }
                        if (partes[1] == 'luz') { atu = 'Iluminação artificial'; icon = 'mdi-ceiling-light-outline' }

                        self.li_ia_exib.push({'atu':atu, 'valor':valor, 'un':`[${partes[2]}]`, 'icon':icon})
                    }
                }
                else { self.flagMsgIAOFF = true }

                self.flagLoading = false
            })
        },
    },

    created() {
        window.scrollTo(0,0)

        this.preInit()
    }
}
</script>